import React from "react";
import Tooltip from "@mui/material/Tooltip";


export const KPIPill = ({title, sampleValue, universeValue, arrow, globalArrow, className, N1, N2, sigma1, sigma2, pValue, fromValue, toValue, mu1, mu2}) => {
    return <div className={"kpi"}>
        <h4>{title}</h4>
        <div className={"kpi-subtext"}>
            <div>
                <p className={"kpi-value"}>{sampleValue}</p>
                {universeValue !== null ? <p className={"universe-value"}><i>({fromValue}→{toValue})</i></p> : null}
                {universeValue !== null ? <p className={"universe-value"}><i>({universeValue} globally {globalArrow})</i></p> : null}
            </div>
            <span className={`trend ${className}`}>{arrow}</span>
        </div>
        <div className={"kpi-confidence"}>
            <Tooltip
                title={"We did a t-test to assert that the second half of your date range is greater than the first half. A p<0.05 give a ~95% confidence range. Outside that take the trend with a grain of salt."}>p={pValue || "?"}</Tooltip>
            <br/>
            <Tooltip
                title={"This shows you how many data points were in the first half of your date range. Small numbers are bad. More than ~7 are good. Just go by the p-value for confidence."}>
                N<sub>1</sub>={N1}
            </Tooltip>,
            <Tooltip
                title={"This shows you how many data points were in the second half of your date range. Small numbers are bad. More than ~7 are good. Just go by the p-value for confidence."}>
                N<sub>2</sub>={N2}
            </Tooltip>
            <br/>
            <Tooltip
                title={"For the pro users; this is the standard deviation of the first half of your date range. If you see a big difference between this and the second half, or a number that's big compared to the mean; the trend is more likely to be uncertain."}>
                σ<sub>1</sub>={sigma1?.toFixed(1)},
            </Tooltip>
            <Tooltip
                title={"For the pro users; this is the standard deviation of the first half of your date range. If you see a big difference between this and the second half, or a number that's big compared to the mean; the trend is more likely to be uncertain."}>
                σ<sub>2</sub>={sigma2?.toFixed(1)}
            </Tooltip>
            <br/>
            <Tooltip title={"Sample means"}>
                {`μ₁=${mu1?.toFixed(1)} μ₂=${mu2?.toFixed(1)}`}
            </Tooltip>
        </div>
    </div>;
};